/* eslint-disable max-len */
import { LicenseInfo } from '@mui/x-license';

const KEY =
  'ce0ed69f001dfabc841fa386ea5f7b15Tz0xMTAyNjYsRT0xNzc0NDgzMTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=';

LicenseInfo.setLicenseKey(KEY);
